<div class="preview-modal">
  <div
    class="preview-modal__close"
    (click)="closeModal($event)"
    (keydown)="closeModal($event)"
    tabindex="0"
  >
    <ui-svg-icon
      svgId="close"
      iconClassName="preview-modal--close"
    ></ui-svg-icon>
  </div>
  <div class="preview-modal__content" *ngIf="data">
    <ng-container [ngSwitch]="data.fileType">
      <ng-container *ngSwitchCase="previewModalDataType.image">
        <div
          class="preview-modal__content__image"
          *ngIf="resourceUrl$ | async as url"
        >
          <img *ngIf="url !== ''" [src]="url" alt="image preview" />
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="previewModalDataType.pdf">
        <div
          class="preview-modal__content__pdf"
          *ngIf="resourceUrl$ | async as url"
        >
          <pdf-viewer
            class="preview-modal__content__pdf__viewer"
            [src]="url"
            [render-text]="false"
            [original-size]="false"
            [zoom]="0.9"
          ></pdf-viewer>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="previewModalDataType.notSupported">
        File type not supported.
      </ng-container>
    </ng-container>
  </div>
</div>
